<template>
  <div>
    <div class="form-group-style">
      <el-form class="form-container" :model="platform" :rules="platformRules" ref="platForm">
        <div class="form-item">
          <div class="form-label">
            <span class="label">平台名称</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="name">
              <el-input class="input-control" v-model="platform.name"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">平台LOGO</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <div
              class="upload-group clearfix"
              v-if="platform.logo_path && platform.logo_path !== ''"
            >
              <div class="upload-item">
                <img :src="platform.logo_url" alt />
                <div class="shadow">
                  <i class="el-icon-delete" @click="clearUpload(1)"></i>
                </div>
              </div>
            </div>
            <el-form-item prop="logo_path">
              <div class="upload-group-1" v-if="platform.logo_path=='' || !platform.logo_path">
                <i class="el-icon-plus"></i>
                <input
                  type="file"
                  class="type-file"
                  accept="*"
                  @change="checkFile($event,1)"
                  id="pictureUploadFile1"
                />
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">平台二维码</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <div
              class="upload-group clearfix"
              v-if="platform.qrcode_path && platform.qrcode_path !== ''"
            >
              <div class="upload-item">
                <img :src="platform.qrcode_url" alt />
                <div class="shadow">
                  <i class="el-icon-delete" @click="clearUpload(2)"></i>
                </div>
              </div>
            </div>
            <el-form-item prop="qrcode_path">
              <div class="upload-group-1" v-if="platform.qrcode_path=='' || !platform.qrcode_path">
                <i class="el-icon-plus"></i>
                <input
                  type="file"
                  class="type-file"
                  accept="*"
                  @change="checkFile($event,2)"
                  id="pictureUploadFile2"
                />
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">公司名称</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="company_name">
              <el-input
                placeholder="请输入公司名称"
                class="input-control"
                v-model="platform.company_name"
                type="text"
              ></el-input>
            </el-form-item>
          </div>
        </div>
          <div class="form-item">
          <div class="form-label">
            <span class="label">公司地址</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="company_address">
              <el-input
                placeholder="请输入公司地址"
                class="input-control"
                v-model="platform.company_address"
                type="text"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">服务热线</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="tel">
              <el-input
                placeholder="请输入服务热线"
                class="input-control"
                v-model="platform.tel"
                type="text"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">加盟热线</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="join_tel">
              <el-input placeholder="请输入加盟热线" class="input-control" v-model="platform.join_tel"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">客服邮箱</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="email">
              <el-input
                type="text"
                placeholder="请输入客服邮箱"
                class="input-control"
                v-model="platform.email"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">ICP备案</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="icp">
              <el-input
                type="text"
                placeholder="请输入ICP备案"
                class="input-control"
                v-model="platform.icp"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label" style="width:120px;line-height: 20px;">PC端平台统计代码{{host}}</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="statics_code">
              <el-input
                type="textarea"
                placeholder="平台统计代码"
                class="input-control"
                v-model="platform.statics_code"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label" style="width:115px;line-height: 20px;">M端平台统计代码{{"m."+host}}</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="statics_code">
              <el-input
                type="textarea"
                placeholder="平台统计代码"
                class="input-control"
                v-model="platform.m_statics_code"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">用户协议</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="aggrement">
              <editor-bar v-model="platform.contract" :isClear="isClear"></editor-bar>
            </el-form-item>
          </div>
        </div>
        <div class="form-button">
          <el-button type="primary" v-permission="'user.platform.edit'" @click="submitForm('platForm')">保 存</el-button>
          <el-button type="info" plain @click="toWelcome()">取 消</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { validateEmpty, validateNumber, validEmail } from "@/utils/validate";
import { mapGetters } from "vuex";
import { getUser } from "@/utils/auth";
import { uploadFile, getPlatformInfo, setPlatformInfo } from "@/service/user";
import { UPLOAD_CODE } from "@/config/index";
import { fetchPut } from "@/utils/request";
import EditorBar from "@/components/editoritem/wangEditor";
export default {
  name: "platform",
  components: {
    EditorBar
  },
  data() {
    return {
      host:"",
      platform: {
        name: "",
        logo_path: null,
        qrcode_path: null,
        logo_url: null,
        qrcode_url: null,
        company_name: "",
        tel: "",
        join_tel: "",
        email: "",
        icp: "",
        statics_code: "",
        contract: ""
      },
      isClear: false,
      htmlContent: "",
      roleName: "",
      sites: "",
      platformRules: {
        name: [
          { required: true, message: "请填写平台名称", trigger: "blur" },
          { min: 2, max: 64, message: "长度在 2 到 64 个字符", trigger: "blur" }
        ],
        company_name: [
          { required: true, message: "请填写公司名称", trigger: "blur" },
          { min: 2, max: 64, message: "长度2到64个字符" }
        ],
        company_address:[
          { required: true, message: "请填写公司地址", trigger: "blur" },
          { min: 2, max: 64, message: "长度2到64个字符" }
        ],
        tel: [
          { required: true, message: "请填写服务热线" , trigger: "blur" },
          { min: 2, max: 64, message: "长度在 2 到 64 个字符"},
        ],
        join_tel: [
          { required: true, message: "请填写加盟热线" , trigger: "blur"},
          { min: 2, max: 64, message: "长度在 2 到 64 个字符" },
        ],
        email: [
          { required: true, message: "请填写客服邮箱", trigger: "blur" },
          { min: 2, max: 64, message: "长度在 2 到 64 个字符" },
          { result: "客服邮箱", trigger: "blur", validator: validEmail }
        ],
        icp: [{ required: true, message: "请填写ICP备案", trigger: "blur"},
        { min: 2, max: 64, message: "长度在 2 到 64 个字符" },
        ],
        statics_code: [
          { required: true, message: "请填写平台统计代码", trigger: "blur" }
        ],
        contract: [
          { required: true, message: "请填写用户协议", trigger: "blur" }
        ],
        logo_path: [{ required: true, message: "请上传LOGO" }],
        qrcode_path: [{ required: true, message: "请上传二维码"}]
      }
    };
  },
  computed: {
    ...mapGetters(["user_info"])
  },
  mounted() {
    this.getPlatinfo();
    this.host = window.serverConfig[window.siteMap[document.domain]].HOST
  },
  methods: {
    toWelcome() {
      this.$router.push("/home/index/welcome");
    },
    getPlatinfo() {
      //获取平台资料
      getPlatformInfo({}).then(data => {
      
        let info = { ...data };
        if (JSON.stringify(info) != "{}") {
          this.platform = info;
        }
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          setPlatformInfo(this.platform)
            .then(data => {
              this.$message({
                message: "修改成功",
                type: "success",
                duration: 3 * 1000
              });
              this.getPlatinfo();
            })
            .catch(err => {
              const message = err.context ? err.context[0] : err.message;
              this.$message({
                message: message || "修改失败",
                type: "error",
                duration: 3 * 1000
              });
            });
        } else {
          return false;
        }
      });
    },
    // 文件上传
    checkFile(e, type) {
      const file = e.target;
      const filePath = file.value;
      if (!filePath) return false;
      // 验证格式是否匹配
     if(!/.(jpg|jpeg|png)$/.test(filePath)){
        this.$message({
            type: 'error',
            message: '请选择JPG/PNG格式的图片'
        })
        return false
      }
      // 验证上传文件大小
      const fileSize = file.files[0].size;
      if (fileSize / 1024 > 1024) {
        this.$message({
          type: "error",
          message: "上传的图片不能大于1M"
        });
        return false;
      }
      this.upload(file, type);
    },
    // 上传LOGO和二维码
    async upload(file, type) {
      try {
        const formData = new FormData();
        formData.append("file", file.files[0]);
        formData.append("code", UPLOAD_CODE.platform);
        const res = await uploadFile(UPLOAD_CODE.platform, formData);
        if (type == 1) {
          this.$set(this.platform, "logo_path", res.path);
           this.platform.logo_url= "https://" + res.full_url + "!watermark"
        } else {
          this.$set(this.platform, "qrcode_path", res.path);
          this.platform.qrcode_url= "https://" + res.full_url + "!watermark"
        }
      } catch (error) {
        if (type == 1) {
          this.$message({
            type: "error",
            message: error.message || "上传LOGO错误"
          });
        } else {
          this.$message({
            type: "error",
            message: error.message || "上传二维码错误"
          });
        }
      }
    },
    // 清空上传
    clearUpload(type) {
      if (type == 1) {
        this.$set(this.platform, "logo_path", "");
        this.$set(this.platform, "logo_url", "");
        document.querySelector("#pictureUploadFile1").value = "";
      } else if (type == 2) {
        this.$set(this.platform, "qrcode_path", "");
        this.$set(this.platform, "qrcode_url", "");
        document.querySelector("#pictureUploadFile2").value = "";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.upload-group-1 {
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  .el-icon-plus {
    font-size: 30px;
    color: #999;
  }
  .type-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100% !important;
    opacity: 0;
    cursor: pointer;
  }
}
.upload-group {
  //   padding-left: 15%;
  .upload-item {
    width: 150px;
    height: 150px;
    position: relative;
    float: left;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
    .shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: -webkit-box;
      -webkit-box-align: center;
      -webkit-box-pack: center;
      cursor: pointer;
      transition: all 0.1s linear;
      opacity: 0;
      .el-icon-delete {
        font-size: 21px;
        color: #fff;
        display: block;
      }
    }
    &:hover {
      .shadow {
        opacity: 1;
      }
    }
    .el-icon-close {
      position: absolute;
    }
  }
}
</style>